<!-- alert  -->
<div class="alert flex flex-row items-center bg-yellow-200 p-5 rounded border-b-2 border-yellow-300 mt-5"
     *ngIf="pVariant.length == 0 && countTable == 0 && isInit">
      <span class="text-yellow-500">
         <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-alert-circle" width="48" height="48" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <circle cx="12" cy="12" r="9"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
         </svg>
      </span>
   <div class="alert-content ml-4">
      <div class="alert-title font-semibold text-lg text-yellow-800">
         Non ci sono varianti registrate.
      </div>
      <div class="alert-description text-sm text-yellow-600" *ngIf="tabs">
         Prima di creare le taglie, crea almeno una <a class="cursor-pointer"
                                                       (click)="clickChangeTab()">variante</a>.
      </div>
      <div class="alert-description text-sm text-yellow-600" *ngIf="!tabs">
         Prima di creare le taglie, crea almeno una variante.
      </div>
   </div>
</div>

<div *ngIf="!isInit" class="pt-2">
   <app-skeleton [items]="[[3],[0],[0],[0]]"></app-skeleton>
</div>

<dx-data-grid #gridInstances
              [columnAutoWidth]="true"
              class="my-3"
              [hidden]="(pVariant.length == 0 && countTable == 0) || !isInit">

   <dxo-header-filter [visible]="true"></dxo-header-filter>

   <dxo-editing mode="cell" [allowUpdating]="true" ></dxo-editing>

   <dxi-column [allowEditing]="false" dataField="id" width="80" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="ID"></dxi-column>
   <dxi-column [allowEditing]="false" dataField="p_variant_codice" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Codice variante"></dxi-column>
   <dxi-column [allowEditing]="false" dataField="p_variant_colore" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Colore"></dxi-column>

   <dxi-column dataField="ean" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="EAN" cellTemplate="eanTemplate"></dxi-column>
   <div *dxTemplate="let cellInfo of 'eanTemplate'">
      <span *ngIf="cellInfo.data.ean; else eanPlaceholder">{{cellInfo.data.ean}}</span>
      <ng-template #eanPlaceholder>
         <span class="text-gray-400">Inserisci EAN</span>
      </ng-template>
   </div>
   <dxi-column dataField="sku"  [allowHeaderFiltering]="false" [allowFiltering]="true" caption="SKU"></dxi-column>
   <dxi-column dataField="metrica_1_nome"  [allowEditing]="false" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Tabella taglie 1"></dxi-column>
   <dxi-column dataField="metrica_1_val"  [allowEditing]="false" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Metrica 1"></dxi-column>
   <dxi-column dataField="metrica_2_nome"  [allowEditing]="false" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Tabella taglie 2"></dxi-column>
   <dxi-column dataField="metrica_2_val" [allowEditing]="false" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Metrica 2"></dxi-column>
   <!--      <dxi-column dataField="metrica_3_val" width="100" [allowEditing]="false" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Metrica 3"></dxi-column>-->

</dx-data-grid>
